module.exports = __webpack_public_path__ + "img/img-8.34105903.png";